module.exports = __webpack_public_path__ + "static/img/A37.0b5ccde3.jpg";